const StatementsTab: React.FC = () => {
  return (
    <div className="rounded-xl border bg-white p-6">
      <h2 className="text-xl font-semibold">Statements</h2>
      <p className="mt-2 text-gray-500">
        Download annual / quarterly statements here.
      </p>
    </div>
  );
};

export default StatementsTab;
